export default __webpack_public_path__ + "media/flags/pr-d243c197.svg";